import React from 'react'
import schema from '../jsonschemas/infrastructure/infrastructure_2/infrastructure_two.json'
import uiSchema from '../jsonschemas/infrastructure/infrastructure_2/web_ui_schema.json'
import { FormPreview } from './FormPreview'

export function TestSchema2() {
  return <FormPreview schema={schema} uiSchema={uiSchema} />
}
